import { notification } from 'antd'
import { useState } from 'react'
import { useContext } from 'use-context-selector'

import { PromoPageStateContext } from 'states/PromoPageState/PromoPageStateProvider'
import { saveSection } from 'states/PromoPageState/reducer'
import { SectionState } from 'states/PromoPageState/state'
import { SortingCenterType } from 'sections/PromoSection/pages/ListPages/ListSignBoardsSortingCentersPage/types'
import { AdminHeaderBlockElem } from 'components/AdminV2/UI/HeaderBlockElem/AdminHeaderBlockElem'
import { AdminInput } from 'components/AdminV2/UI/Input/AdminInput'
import { AdminSaveButton } from 'components/AdminV2/UI/SaveButton/AdminSaveButton'
import { AdminTextArea } from 'components/AdminV2/UI/TextArea/AdminTextArea'
import { SortingCentersData } from 'types/types'

import s from './SortingCenterBlockItem.module.scss'

type SortingCenterBlockItemProps = {
  index: number
  localPromoState: SectionState
  sortingCenter: SortingCenterType
  setLocalPromoState: React.Dispatch<React.SetStateAction<SectionState>>
  handleSave: (sortingCenter: SortingCenterType) => void
}

export const SortingCenterBlockItem = ({
  sortingCenter,
  localPromoState,
  index,
  setLocalPromoState,
  handleSave,
}: SortingCenterBlockItemProps) => {
  const ctx = useContext(PromoPageStateContext)

  const [sortingCenterLocal, setSortingCenterLocal] = useState(sortingCenter)

  const disabled =
    sortingCenterLocal.city.trim().length === 0 ||
    sortingCenterLocal.address.trim().length === 0 ||
    sortingCenterLocal.workTime.trim().length === 0

  const deleteConferenceHandler = () => {
    const stateCopy = { ...localPromoState }
    const data = stateCopy.content as SortingCentersData

    const filteredSortingCenters = data.sortingCentersData.filter((sortingCenter) => sortingCenter.index !== index)

    for (let i = 0; i < filteredSortingCenters.length; i++) {
      filteredSortingCenters[i].index = i
    }

    data.sortingCentersData = filteredSortingCenters
    setLocalPromoState(stateCopy)

    ctx.dispatch(saveSection(stateCopy))
  }

  const handleConferenceSave = () => {
    notification.success({
      message: 'Изменения сохранены!',
    })
    handleSave({ ...sortingCenterLocal })
  }

  const changeInputHandler = (value: string, key: keyof SortingCenterType) => {
    setSortingCenterLocal({ ...sortingCenterLocal, [key]: value })
  }

  return (
    <div className={s.wrap}>
      <AdminHeaderBlockElem index={index} text={'Сортировочный центр'} onClick={deleteConferenceHandler} />

      <AdminInput
        label="Регион (максимум 200 символов)"
        value={sortingCenterLocal.city}
        onChange={(value: string) => changeInputHandler(value, 'city')}
        labelSize="16px"
        maxLength={200}
      />

      <AdminTextArea
        label="Адрес (максимум 300 символов)"
        value={sortingCenterLocal.address}
        onChange={(value: string) => changeInputHandler(value, 'address')}
        labelSize="16px"
        maxLength={300}
      />

      <AdminTextArea
        label="Время работы (максимум 200 символов)"
        value={sortingCenterLocal.workTime}
        onChange={(value: string) => changeInputHandler(value, 'workTime')}
        labelSize="16px"
        maxLength={200}
      />

      <AdminSaveButton onClick={handleConferenceSave} text="Сохранить данные" disabled={disabled} showSuccess={false} />
    </div>
  )
}
